import axios from 'axios'

import { getBaseUrl, getDefaultHeaders } from './middleware'

export const basicApi = axios.create()

basicApi.interceptors.request.use(
  async (config) => getBaseUrl(config).then(getDefaultHeaders),
  (error) => Promise.reject(error),
)
